let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8dFbw")).then(() => parcelRequire('hJzxL'));